/**
 * Boxful Physical AI tech page - page shell: init, drawer, language menu, modal, lead form
 * Source design: boxful_app 2/tech/ (static mockup)
 */

// ==========================================================================
// [설정] 구글 스프레드시트 연동 URL (Physical AI 전용 - 홈페이지와 다른 시트)
// 구글 스프레드시트 > 확장 프로그램 > Apps Script 배포 URL
// ==========================================================================
const TECH_SHEETS_WEBAPP_URL = "https://script.google.com/macros/s/AKfycbzAdN-DWj7uTO8nRDUOu_B8iMG9KioYGRWqdtJexAry8MgIutHc2_AqiU85oseycrqqCA/exec";


// Initialize on DOM Loaded
document.addEventListener("DOMContentLoaded", () => {
  initTaskSelector();
  renderInspector(currentTaskKey);
  initWaveformCanvas();
  initTechLanguageLabel();
});

// ==========================================================================
// Language Selector
// The mockup ships no translation dictionary for this page, so the selector
// only tracks the chosen locale label and shares the key with the home page.
// ==========================================================================
const TECH_LANG_LABELS = {
  ko: '🇰🇷 한국어',
  en: '🇺🇸 English',
  zh: '🇨🇳 中文',
  ja: '🇯🇵 日本語',
  ru: '🇷🇺 Русский',
  vi: '🇻🇳 Tiếng Việt'
};

// The copy on this page is Korean only, so the label falls back to ko instead of
// the app locale - a saved choice still wins so the switcher stays responsive.
function initTechLanguageLabel() {
  applyTechLangLabel(localStorage.getItem('boxful_lang') || 'ko');
}

function applyTechLangLabel(lang) {
  const label = document.getElementById('currentTechLangLabel');
  if (label) {
    label.innerText = TECH_LANG_LABELS[lang] || TECH_LANG_LABELS.ko;
  }
  document.documentElement.lang = lang;
}

function toggleTechLangDropdown(event) {
  if (event) event.stopPropagation();
  const dropdown = document.getElementById('techLangDropdown');
  if (!dropdown) return;
  dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
}

function switchTechLanguage(lang) {
  localStorage.setItem('boxful_lang', lang);
  applyTechLangLabel(lang);

  const dropdown = document.getElementById('techLangDropdown');
  if (dropdown) dropdown.style.display = 'none';

  const drawer = document.getElementById('techMobileDrawer');
  if (drawer && !drawer.classList.contains('hidden')) {
    drawer.classList.add('hidden');
  }
}

// Close the language dropdown when clicking outside of it
document.addEventListener('click', (event) => {
  const dropdown = document.getElementById('techLangDropdown');
  if (dropdown && !event.target.closest('.lang-selector-wrapper')) {
    dropdown.style.display = 'none';
  }
});

// Sample Dataset Download / Request Modal
function openSampleRequestModal(category) {
  const modal = document.getElementById("sampleModal");
  if (modal) {
    if (category) {
      document.getElementById("modalSelectedCat").value = category;
    }
    modal.classList.remove("hidden");
  }
}

function closeSampleModal() {
  const modal = document.getElementById("sampleModal");
  if (modal) {
    modal.classList.add("hidden");
  }
}

// ==========================================================================
// Form Handler (Real-time Google Spreadsheet Submission)
// no-cors is required because Apps Script sends no CORS headers, which means
// the response is opaque - a failed write cannot be detected from the browser.
// ==========================================================================
async function handleDatasetInquiry(e) {
  e.preventDefault();

  const submitBtn = e.target.querySelector('button[type="submit"]');
  const originalBtnText = submitBtn ? submitBtn.innerHTML : '';

  const name = document.getElementById("inqName").value.trim();
  const company = document.getElementById("inqCompany").value.trim();
  const email = document.getElementById("inqEmail").value.trim();
  const planSelect = document.getElementById("inqPlan");
  const plan = planSelect ? planSelect.value : '';
  const planLabel = planSelect ? planSelect.options[planSelect.selectedIndex].text : '';
  const req = document.getElementById("inqReq").value.trim();

  // BXF-AI prefix keeps Physical AI leads apart from the fulfillment ones
  const ticketId = 'BXF-AI-' + Math.floor(100000 + Math.random() * 900000);
  const timestamp = new Date().toLocaleString('ko-KR', { timeZone: 'Asia/Seoul' });

  const payload = {
    ticketId: ticketId,
    timestamp: timestamp,
    name: name,
    company: company,
    email: email,
    plan: plan,
    planLabel: planLabel,
    requirements: req,
    source: 'tech-physical-ai',
    lang: (localStorage.getItem('boxful_lang') || 'ko').toUpperCase()
  };

  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.innerHTML = '⏳ 데이터 공급 신청 전송 중...';
    submitBtn.style.opacity = '0.8';
  }

  try {
    await fetch(TECH_SHEETS_WEBAPP_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });
  } catch (err) {
    console.warn('[Physical AI Sheets Sync Notice] Request sent:', err);
  } finally {
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalBtnText;
      submitBtn.style.opacity = '1';
    }

    alert(`[Physical AI 데이터 공급 신청 완료]\n\n담당자: ${name} (${company})\n이메일: ${email}\n관심 플랜: ${planLabel}\n접수번호: ${ticketId}\n\n박스풀 AI 데이터 비즈니스 팀에서 24시간 이내에 샘플 데이터셋 및 맞춤 데이터 공급 제안서를 송부해 드립니다.`);
    e.target.reset();
  }
}

function handleSampleModalSubmit(e) {
  e.preventDefault();
  alert("샘플 데이터셋 다운로드 링크가 기재하신 이메일로 즉시 발송되었습니다! (ROS2 / HDF5 / JSON 포맷 포함)");
  closeSampleModal();
  e.target.reset();
}

// Mobile Menu Toggle for Tech Site
function toggleTechMobileMenu() {
  const drawer = document.getElementById("techMobileDrawer");
  if (drawer) {
    drawer.classList.toggle("hidden");
  }
}
